import { Grid2X2, LogOut, User, TrendingDown } from 'lucide-react'

import { logoIconUrl, logoUrl } from '../../assets/clinicAssets'

export default function Topbar({ activeTab, onChange, onLogout }) {
  return (
    <header className="px-4 pt-4 sm:px-6 lg:px-8 lg:pt-0">
      <div className="flex h-auto flex-col gap-4 lg:h-0 lg:flex-row lg:items-center lg:justify-end lg:gap-5">
        <div className="flex items-center justify-between lg:hidden">
          <div className="flex items-center gap-3">
            <div className="h-11 w-36 overflow-hidden rounded-md">
              <img
                alt="Odonto Clinic"
                className="h-full w-full object-contain object-left"
                src={logoUrl}
              />
            </div>
          </div>

          <button
            className="flex h-10 w-10 items-center justify-center rounded-full text-[#5A5147] transition hover:bg-[#F8E1E7] hover:text-[#1A1A1A]"
            type="button"
            aria-label="Sair"
            title="Sair"
            onClick={onLogout}
          >
            <LogOut size={18} strokeWidth={2.3} aria-hidden="true" />
          </button>
        </div>

        <nav className="grid grid-cols-3 gap-3 lg:hidden">
          <MobileNavItem
            icon={Grid2X2}
            isActive={activeTab === 'dashboard'}
            label="Dashboard"
            onClick={() => onChange('dashboard')}
          />
          <MobileNavItem
            icon={User}
            isActive={activeTab === 'patients'}
            label="Pacientes"
            onClick={() => onChange('patients')}
          />
          <MobileNavItem
            icon={TrendingDown}
            isActive={activeTab === 'expenses'}
            label="Saídas"
            onClick={() => onChange('expenses')}
          />
        </nav>
      </div>
    </header>
  )
}

function MobileNavItem({ icon: Icon, isActive, label, onClick }) {
  return (
    <button
      className={`flex h-12 items-center justify-center gap-2 rounded-lg text-base font-bold ${
        isActive ? 'bg-[#F8E1E7] text-[#5A5147]' : 'bg-white text-[#5A5147]'
      }`}
      type="button"
      onClick={onClick}
    >
      <Icon size={20} strokeWidth={2.4} />
      {label}
    </button>
  )
}
